module.exports = __webpack_public_path__ + "img/9791165508876.5912a301.jpg";